import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import {States} from "../../shared/config/constant.module";
import template from './morningMinutesReport.tpl.html';
import {Plant} from "../../models/navigation";
import {StateParams} from "../../common";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import MorningMinutesReportHubName, {MorningMinutesReportHub, MorningMinutesReportHubService} from "../../services/reports/morningMinutesReport.hub";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import {apsEvents} from "../../shared/dto/aps.events";

let requires = [LoaderServiceName, ReportServiceName, AuthDataServiceName, MorningMinutesReportHubName, NavigationServiceName];
  
interface MorningMinutesReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;

  isAdmin(): boolean;
  generateReport(regenerate: boolean): void;
}

export interface MorningMinutesReportParams extends StateParams {
  reportPlantId: string;
  reportDate: string;
}

class MorningMinutesReportCtrl implements MorningMinutesReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;

  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  authDataService: AuthDataService;
  $q: angular.IQService;
  morningMinutesReportHubService: MorningMinutesReportHubService;
  morningMinutesReportHub: MorningMinutesReportHub;

  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;
  private $stateParams: MorningMinutesReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: MorningMinutesReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    morningMinutesReportHubService: MorningMinutesReportHubService,
    $q: angular.IQService) {

    var vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.authDataService = authDataService;
    this.morningMinutesReportHubService = morningMinutesReportHubService;
    this.$q = $q;

    this.reportDate = moment().clone().startOf('day').toDate();

    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;

      this.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);

    this.reportAvailableThisWorkaround = {
      workaround: function (reportAvailable: apsEvents.MorningMinutesReportInstanceAvailable) {
        vm.reportAvailable(reportAvailable);
      }
    };
  }

  isAdmin() {
    return this.selectedPlant
      && this.authDataService.isPlantAdmin(this.selectedPlant.id);
  }

  loadState(params: MorningMinutesReportParams): void {
    if (params.reportPlantId && params.reportPlantId !== params.plantId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        this.selectedPlant = plant;
      }
    }

    if (params.reportDate) {
      var reportDate = moment(params.reportDate);
      if (reportDate.isValid()) {
        this.reportDate = reportDate.toDate();
      }
    }
  }

  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
    var params: MorningMinutesReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(regenerate: boolean) {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    this.loaderService.loadingPromise(this.runReport(regenerate));
  }

  private runReport(regenerate: boolean): angular.IPromise<any> {
    this.morningMinutesReportHub = this.morningMinutesReportHubService
      .createMorningMinutesReportHub(
        this.reportAvailableThisWorkaround.workaround,
        this.selectedPlant.id,
        this.reportDate,
        regenerate);

    var loadingPromise = this.morningMinutesReportHub.promise.then(() => {
      return this.reportService.generateMorningMinutesReport(
        this.selectedPlant.id,
        this.reportDate,
        regenerate || false);
    });

    this.reportLoadingPromise = this.$q.defer();
    return this.$q.all([loadingPromise, this.reportLoadingPromise.promise]);
  }

  reportAvailable(reportAvailable: apsEvents.MorningMinutesReportInstanceAvailable) {
    var resolveLoadingPromise = () => {
      this.reportService.getMorningMinutesReport(reportAvailable.plantId, reportAvailable.date);

      if (this.reportLoadingPromise) {
        this.reportLoadingPromise.resolve();
      }
    };

    if (this.morningMinutesReportHub) {
      this.morningMinutesReportHub.deregisterListeners();
      this.morningMinutesReportHub.leaveGroup(this.selectedPlant.id).then(() => {
        resolveLoadingPromise();
      });
    } else {
      resolveLoadingPromise();
    }
  }
}

export default angular.module('aps.controller.morningMinutesReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.MORNING_MINUTES_REPORT,
      url: '/admin/reports/morningMinutes?reportDate&reportPlantId',
      params: {
        reportDate: {dynamic: true},
        reportPlantId: {dynamic: true}
      },
      controller: 'MorningMinutesReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Morning Minutes Report'
      }
    });
  })
  .controller('MorningMinutesReportCtrl', MorningMinutesReportCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/morningMinutesReport.controller.ts